'use strict';

angular.module('amexReconciliationApp')
  .service('ExceptionNoteTranslationService',
    function ExceptionNoteTranslationService($translate) {

      var self = this;

      self.translateExceptionNote = function translateExceptionNote(exceptionNote, exceptionCodes) {
        return _.join(_.map(_.split(exceptionNote,' '), function(string) {
          if (_.startsWith(string, '@')) {
            return translateExceptionCode(string, exceptionCodes);
          }
          return string;
        }), ' ');
      };

      self.encodeExceptionNote = function encodeExceptionNote(exceptionNote, exceptionCodes) {
        _.forEach(exceptionCodes,function(translatedString, code) {
          exceptionNote = _.replace(exceptionNote,translatedString, code);
        });
        return exceptionNote;
      };

      function translateExceptionCode(exceptionCode, exceptionCodes) {
        var parsedCode = parseExceptionCode(exceptionCode);

        var translated = $translate.instant('transactions.transactionDetails.exceptionCodes.' + parsedCode.code, parsedCode.parameters);

        if (translated === 'transactions.transactionDetails.exceptionCodes.' + parsedCode.code) {
          return exceptionCode;
        } else {
          if (exceptionCodes) {
            exceptionCodes[exceptionCode] = translated;
          }
          return translated;
        }
      }

      function parseExceptionCode(exceptionCode) {
        var parsedString = _.split(exceptionCode, '~');
        var parsedCode = {code: '', parameters: {}};
        _.forEach(parsedString, function(s,index) {
          if (index === 0) {
            parsedCode.code = s;
          } else {
            parsedCode.parameters['param_' + index] = s;
          }
        });
        return parsedCode;
      }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ExceptionNoteTranslationService.js
// module id = 637
// module chunks = 0